import { useTimerContext } from "@/context/TimerContext";

const AssessmentLableAndTimer = ({
	timeLeft,
	label,
}: {
	timeLeft: number;
	label: string;
}) => {
	const { formatTime } = useTimerContext();
	return (
		<div className="bg-[#F6F6F6] dark:bg-zinc-900 py-4 px-3 rounded-t-lg ">
			<div className="flex justify-between items-center gap-3 pt-1 font-heading text-xl">
				<div className=" font-semibold  ">{label}</div>
				<div className=" flex items-center gap-x-2 font-subheading">
					<svg
						width="30"
						height="30"
						viewBox="0 0 30 30"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15 16.25V11.25M26.25 7.5L23.75 5M12.5 2.5H17.5M15 26.25C12.3478 26.25 9.8043 25.1964 7.92893 23.3211C6.05357 21.4457 5 18.9022 5 16.25C5 13.5978 6.05357 11.0543 7.92893 9.17893C9.8043 7.30357 12.3478 6.25 15 6.25C17.6522 6.25 20.1957 7.30357 22.0711 9.17893C23.9464 11.0543 25 13.5978 25 16.25C25 18.9022 23.9464 21.4457 22.0711 23.3211C20.1957 25.1964 17.6522 26.25 15 26.25Z"
							stroke="#1C1C1C"
							strokeWidth="2.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>

					<h1>{formatTime(timeLeft)}</h1>
				</div>
			</div>
		</div>
	);
};

export default AssessmentLableAndTimer;
